module.exports = __webpack_public_path__ + "static/media/logotype-imusica.9f4d42ed.svg";